module.exports = __webpack_public_path__ + "37573896d264a4d8274b12880b21d3bc.png";